import { useTranslation } from "react-i18next";

import {
  useCreatePersonalInformationMutation,
  useEditPersonalInformationMutation,
} from "~/schemas/generated/graphql";
import { useNotify } from "~/shared/hooks/useNotify";

export const personalDataQueryManagement = ({ refetch, closeModal }) => {
  const { notifySuccess, notifyError } = useNotify();
  const { t } = useTranslation();

  const [editPersonalData] = useEditPersonalInformationMutation({
    onCompleted() {
      refetch();
      closeModal();
      notifySuccess(t("common.сhange_was_successful"));
    },
    onError(vals) {
      notifyError(vals["message"]);
    },
  });

  const [addPersonalData] = useCreatePersonalInformationMutation({
    onCompleted() {
      refetch();
      closeModal();
      notifySuccess(t("common.сhange_was_successful"));
    },
    onError(vals) {
      notifyError(vals["message"]);
    },
  });

  return { editPersonalData, addPersonalData };
};
